import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { all_routes } from '../../../router/all_routes'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath'
import PredefinedDateRanges from '../../../../core/common/datePicker'
import { allClass, allSection, gender, names, status } from '../../../../core/common/selectoption/selectoption'
import CommonSelect from '../../../../core/common/commonSelect'
import TooltipOption from '../../../../core/common/tooltipOption'
import UserService from '../../../network/services/UserService'
import StudentModals from '../../../peoples/students/studentModals'
import { getUser } from '../../../network/auth/Auth'
import { Modal, Toast } from 'react-bootstrap'

const AcademyYearGrid = () => {
  const routes = all_routes
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const buttonRef1 = useRef<HTMLSpanElement>(null);

  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove('show');
    }
  };

  const navigation = useNavigate()


  // Définir le type pour vos données d'option
  type OptionType = {
    value: string;
    label: string;
  };

  interface AcademyYearData {
    id: any;
    name: any;
    start_date: any;
    end_date: any;
    academic_term_ids: any;
    term_structure: any;
    company_id: any;
  }

  interface Option {
    id: any;
    name: any;
  }

  interface AcademyTermData {
    id: any;
    name: any;
    term_start_date: any;
    term_end_date: any;
    academic_term_ids: any;
    term_structure: any;
    company_id: any;

  }

  const [academyYears, setAcademyYears] = useState<AcademyYearData[]>([]);
  const [branch, setBranch] = useState<any>();
  const branches = getUser()?.company_ids[0]?.branches;




  const fetchData = async (branch_id: any, company_id: any, item: any) => {
    if (item) {
      setBranch(item.name);
    }
    UserService.getAcamdeyYearByBranchAndComapny(branch_id, company_id, (response: any) => {
      if (response?.data && response?.success) {
        setAcademyYears(response.data);

      } else {
        setAcademyYears([]);
      }
    });
  };

  const fetchDataInit = async (company_id: any) => {
    setBranch('All');
    UserService.getAcamdeyYearByBranchAndComapnyAll(company_id, (response: any) => {
      if (response?.data && response?.success) {
        setAcademyYears(response.data);

      } else {
        setAcademyYears([]);
      }
    });
  };

  useEffect(() => {
    fetchDataInit(getUser()?.company_ids[0]?.id);

  }, []);

  const navigeAcademyYearDetails = (academyYear: any) => {
    navigation(routes.studentDetail, { state: { academyYear: academyYear } })
  }

  const navigeAcademyYearList = () => {
    navigation(routes.academyYearList)
  }


  const buttonRef = useRef<HTMLSpanElement>(null);

  const handleClick = () => {
    console.log('Button clicked!');
  };



  const selectionTermStructure = [
    { value: "two_sem", label: "Two Semesters" },
    { value: "two_sem_qua", label: "Two Semesters subdivided by Quarters" },
    { value: "two_sem_final", label: "Two Semesters subdivided by Quarters and Final Exams" },
    { value: "three_sem", label: "Three Trimesters" },
    { value: "four_Quarter", label: "Four Quarters" },
    { value: "final_year", label: "Final Year Grades subdivided by Quarters" },
    { value: "others", label: "Other(overlapping terms,custom schedules)" },
  ];

  const [isActionSuccessfulEdit, setIsActionSuccessfulEdit] = useState(false);
  const [showDangerToast, setShowDangerToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [isActionSuccessful, setIsActionSuccessful] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<any>({
    name: '',
    start_date: '',
    end_date: '',
    operating_branch_id: '',
    term_structure: '',
  });

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const handleClose2 = () => setShowModal2(false);
  const handleShow2 = () => setShowModal2(true);

  const handleSuccessToastClose = () => {
    setShowSuccessToast(false);
  };

  const handleDangerToastClose = () => {
    setShowDangerToast(false);
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowDangerToast(false);
    }, 3000);
    return () => clearTimeout(timeoutId);
  }, [showDangerToast]);


  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowSuccessToast(false);
    }, 4000);
    return () => clearTimeout(timeoutId);
  }, [showSuccessToast]);

  const [formData, setFormData] = useState({
    name: '',
    start_date: '',
    end_date: '',
    operating_branch_id: '',
    term_structure: '',
  });

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleInputChangeEdite = (e: any) => {
    const { name, value } = e.target;
    setSelectedRecord((prevRecord: any) => ({
      ...prevRecord,
      [name]: value
    }));
  };

  const handleInputChangeEdite2 = (e: any) => {
    const { name, value } = e.target;
    console.log(`Changed ${name} to ${value}`); // Debugging

    setSelectedRecord((prevRecord: any) => ({
      ...prevRecord,
      [name]: {
        id: value,
        name: branches.find((branch: any) => branch.id === value)?.name || '' // Assurez-vous que `name` est mis à jour correctement
      }
    }));
  };

  const handleEdit = (record: any) => {
    setSelectedRecord(record)
    handleShow2()
  };

  const formatDate = (date: Date | string) => {
    if (!date) return '';

    const d = new Date(date);
    const month = `${d.getMonth() + 1}`.padStart(2, '0');
    const day = `${d.getDate()}`.padStart(2, '0');
    const year = d.getFullYear();

    return `${year}-${month}-${day}`;
  };

  const handleSubmit = () => {
    setIsLoading(true)
    const request_data = {
      name: formData.name,
      start_date: formData.start_date,
      end_date: formData.end_date,
      term_structure: formData.term_structure === "" ? selectionTermStructure[0].value : formData.term_structure,
      company_id: getUser()?.company_ids[0]?.id,
      operating_branch_id: formData.operating_branch_id === "" ? getUser()?.company_ids[0]?.branches[0]?.id : parseInt(formData.operating_branch_id, 10),
    };

    UserService.addAcademicYear(request_data, (response: any) => {
      if (response.data && response.success) {
        fetchData(getUser()?.company_ids[0]?.branches[0]?.id, getUser()?.company_ids[0]?.id, branch);
        setIsLoading(false)
        setIsActionSuccessful(true)
        setSuccessMessage('Data saved successfully')
        setShowSuccessToast(true)
        setFormData({
          name: '',
          start_date: '',
          end_date: '',
          operating_branch_id: '',
          term_structure: '',
        });

        setShowModal(false);

      } else {
        setErrorMessage('An error has occurred, please try again.')
        setShowDangerToast(true)
        setIsLoading(false)
      }
    });
  };

  const handleSubmitEdit = () => {
    setIsLoading(true)
    const request_data = {
      name: selectedRecord?.name,
      start_date: selectedRecord?.start_date,
      end_date: selectedRecord?.end_date,
      term_structure: selectedRecord?.term_structure === "" ? selectionTermStructure[0].value : selectedRecord?.term_structure,
      company_id: getUser()?.company_ids[0]?.id,
      operating_branch_id: selectedRecord?.branch_id === undefined ? parseInt(selectedRecord?.operating_branch_id?.id, 10) : parseInt(selectedRecord?.operating_branch_id?.id, 10),
    };


    UserService.editAcademicYear(selectedRecord?.id, request_data, (response: any) => {
      if (response.data && response.success) {
        fetchData(getUser()?.company_ids[0]?.branches[0]?.id, getUser()?.company_ids[0]?.id, branch);
        setIsLoading(false)
        setIsActionSuccessfulEdit(true)

        setFormData({
          name: '',
          start_date: '',
          end_date: '',
          operating_branch_id: '',
          term_structure: '',
        });
        handleClose2()
      } else {
        setErrorMessage('An error has occurred, please try again.')
        setShowDangerToast(true)
        setIsLoading(false)
      }
    });
  };


  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content content-two">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Academic Year</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">Academic Year</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Academic Year Grid
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption />
              {getUser().role === "school_admin" && (<div className="mb-2">
                <Link to="#" className="btn btn-primary d-flex align-items-center" onClick={handleShow}>
                  <i className="ti ti-square-rounded-plus me-2" />
                  Add Academic Year
                </Link>

              </div>)}

            </div>
          </div>
          {/* /Page Header */}
          {/* Filter */}
          <div className="bg-white p-3 border rounded-1 d-flex align-items-center justify-content-between flex-wrap mb-4 pb-0">
            <h4 className="mb-3">Academic Year</h4>
            <div className="d-flex align-items-center flex-wrap">
              <div className="input-icon-start mb-3 me-2 position-relative">
                <PredefinedDateRanges />
              </div>
              <div className="dropdown mb-3 me-2">
                <Link
                  to="#"
                  className="btn btn-outline-light bg-white dropdown-toggle"
                  data-bs-toggle="dropdown"
                  data-bs-auto-close="outside"
                >
                  <i className="ti ti-filter me-2" />
                  Filter
                </Link>
                <div className="dropdown-menu drop-width" ref={dropdownMenuRef}>
                  <form>
                    <div className="d-flex align-items-center border-bottom p-3">
                      <h4>Filter</h4>
                    </div>
                    <div className="p-3 pb-0 border-bottom">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Class</label>
                            <CommonSelect
                              className="select"
                              options={allClass}
                              defaultValue={allClass[0]}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Section</label>
                            <CommonSelect
                              className="select"
                              options={allSection}
                              defaultValue={allSection[0]}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">Name</label>
                            <CommonSelect
                              className="select"
                              options={names}
                              defaultValue={names[0]}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Gender</label>
                            <CommonSelect
                              className="select"
                              options={gender}
                              defaultValue={gender[0]}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Status</label>
                            <CommonSelect
                              className="select"
                              options={status}
                              defaultValue={status[0]}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="p-3 d-flex align-items-center justify-content-end">
                      <Link to="#" className="btn btn-light me-3">
                        Reset
                      </Link>
                      <Link to={routes.studentGrid} className="btn btn-primary" onClick={handleApplyClick}>
                        Apply
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
              <div className="d-flex align-items-center bg-white border rounded-2 p-1 mb-3 me-2">
                <a
                  onClick={() => navigeAcademyYearList()}
                  className="btn btn-icon btn-sm me-1 bg-light primary-hover"
                >
                  <i className="ti ti-list-tree" />
                </a>
                <Link
                  to={routes.studentGrid}
                  className="active btn btn-icon btn-sm primary-hover"
                >
                  <i className="ti ti-grid-dots" />
                </Link>
              </div>
              <div className="dropdown mb-3">
                <Link to="#" className="btn btn-outline-light bg-white dropdown-toggle" data-bs-toggle="dropdown">
                  <i className="ti ti-sort-ascending-2 me-2" />
                  {branch}
                </Link>
                <ul className="dropdown-menu p-3">
                  <li >
                    <a className="dropdown-item rounded-1" onClick={() => fetchDataInit(getUser()?.company_ids[0]?.id)}>
                      All
                    </a>
                  </li>
                  {branches?.map((item: any) => (
                    <li key={item.id}>
                      <a className="dropdown-item rounded-1" onClick={() => fetchData(item.id, getUser()?.company_ids[0]?.id, item)}>
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          {/* /Filter */}
          <div className="row">
            {/* Student Grid */}


            {academyYears && academyYears?.map((item, index) => (
              <div className="col-xxl-3 col-xl-4 col-md-6 d-flex" key={index}>
                <div className="card flex-fill">
                  <div className="card-header d-flex align-items-center justify-content-between">
                    <a className="link-primary" onClick={() => navigeAcademyYearDetails(item)}>
                      {item?.company_id[0]?.name}
                    </a>
                    <div className="d-flex align-items-center">


                      <div className="dropdown">
                        <Link
                          to="#"
                          className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i className="ti ti-dots-vertical fs-14" />
                        </Link>
                        <ul className="dropdown-menu dropdown-menu-right p-3">

                          <li>
                            <Link
                              className="dropdown-item rounded-1"
                              to="#"
                              onClick={() => handleEdit(item)}
                            >
                              <i className="ti ti-edit-circle me-2" />
                              Edit
                            </Link>
                          </li>

                          <li>
                            <Link
                              className="dropdown-item rounded-1"
                              to="#"
                              data-bs-toggle="modal"
                              data-bs-target="#delete-modal"
                            >
                              <i className="ti ti-trash-x me-2" />
                              Delete
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="bg-light-300 rounded-2 p-3 mb-3">
                      <div className="d-flex align-items-center">

                        <div className="ms-2">
                          <h5 className="mb-0">
                            <a
                              onClick={() => navigeAcademyYearDetails(item)}>{item?.name}</a>
                          </h5>

                        </div>
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between gx-2">
                      <div>
                        <p className="mb-0">Start date</p>
                        <p className="text-dark">{item?.start_date}</p>
                      </div>
                      <div>
                        <p className="mb-0">End date</p>
                        <p className="text-dark">{item?.end_date}</p>
                      </div>

                    </div>
                  </div>

                </div>
              </div>))}

            {/* /Student Grid */}

            <div className="col-md-12 text-center">
              {
                isLoading ? (<Link to="#" className="btn btn-primary">
                  <span
                    className="spinner-border spinner-border-sm align-middle me-1"
                    role="status"
                    aria-hidden="true"
                  />
                  Load More ...
                </Link>) : (<Link to="#" className="btn btn-primary">
                  <i className="ti ti-loader-3 me-2" />
                  Load More
                </Link>)
              }
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
      <StudentModals />


      <Modal show={showModal} onHide={handleClose} >
        <Modal.Header >
          <Modal.Title>Add Academic Year</Modal.Title>
          <button
            type="button"
            className="btn-close custom-btn-close"
            onClick={handleClose}

          >
            <i className="ti ti-x" />
          </button>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Name</label>
                    <input type="text" className="form-control" placeholder="Name" name="name" value={formData.name}
                      onChange={handleInputChange} />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Start date</label>
                    <input type="date" className="form-control" name="start_date" value={formData.start_date}
                      onChange={handleInputChange} />

                  </div>
                  <div className="mb-3">
                    <label className="form-label">End date</label>
                    <input type="date" className="form-control" name="end_date"
                      value={formData.end_date}
                      onChange={handleInputChange} />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Term Structure</label>
                    <select

                      className="select react-select form-control"
                      name="term_structure"
                      onChange={handleInputChange}
                    >
                      <option >Select Term Structure</option>
                      {selectionTermStructure && selectionTermStructure?.map((item: any) => (
                        <option key={item.value} value={item.value}>{item.label}</option>
                      ))}

                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Branch</label>
                    <select

                      className="select react-select form-control"
                      name="operating_branch_id"
                      onChange={handleInputChange}
                    >
                      <option >Select Branch</option>
                      {branches && branches?.map((item: any) => (
                        <option key={item.id} value={item.id}>{item.name}</option>
                      ))}

                    </select>
                  </div>


                </div>
              </div>
            </div>
            <div className="modal-footer">
              <span
                className="btn btn-light me-2"
                onClick={handleClose}
              >
                Cancel
              </span>
              <Link to="#" className="btn btn-primary" onClick={handleSubmit}  >
                {isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm align-middle me-1"
                      role="status"
                      aria-hidden="true"
                    />
                    Loading...
                  </>
                ) : "Add Academic year"}

              </Link>
            </div>
          </form>
        </Modal.Body>

      </Modal>

      <Modal show={showModal2} onHide={handleClose2} >
        <Modal.Header >
          <Modal.Title>Edit Academic Year</Modal.Title>
          <button
            type="button"
            className="btn-close custom-btn-close"
            onClick={handleClose2}

          >
            <i className="ti ti-x" />
          </button>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Name</label>
                    <input type="text" className="form-control" placeholder="Name" name="name" value={selectedRecord?.name}
                      onChange={handleInputChangeEdite} />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Start date</label>
                    <input type="date" className="form-control" name="start_date" value={formatDate(selectedRecord?.start_date)}
                      onChange={handleInputChangeEdite} />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">End date</label>
                    <input type="date" className="form-control" name="end_date"
                      value={selectedRecord?.end_date}
                      onChange={handleInputChangeEdite} />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Term Structure</label>
                    <select

                      className="select react-select form-control"
                      name="term_structure"
                      value={selectedRecord?.term_structure} // Valeur sélectionnée
                      onChange={handleInputChangeEdite}
                    >

                      {selectionTermStructure && selectionTermStructure?.map((item: any) => (
                        <option key={item.value} value={item.value}>{item.label}</option>
                      ))}

                    </select>
                  </div>


                  <div className="mb-3">
                    <label className="form-label">Branch</label>
                    <select
                      className="select react-select form-control"
                      name="operating_branch_id"
                      value={selectedRecord?.operating_branch_id?.id || ''} // Assurez-vous que cette valeur correspond à une option
                      onChange={handleInputChangeEdite2}
                    >
                      <option value="">Select a branch</option>
                      {branches && branches.map((item: any) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>

                  </div>


                </div>
              </div>
            </div>
            <div className="modal-footer">
              <span
                className="btn btn-light me-2"
                onClick={handleClose2}
              >
                Cancel
              </span>
              <Link to="#" className="btn btn-primary" onClick={handleSubmitEdit}  >
                {isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm align-middle me-1"
                      role="status"
                      aria-hidden="true"
                    />
                    Loading...
                  </>
                ) : "Edit Academic year"}

              </Link>
            </div>
          </form>
        </Modal.Body>

      </Modal>

      <Toast
        show={showDangerToast}
        onClose={handleDangerToastClose}
        id="dangerToast"
        className="toast-container position-fixed top-0 end-0 p-3 colored-toast bg-danger-transparent"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        style={{ minWidth: "200px!important" }}
      >
        <Toast.Header closeButton className="bg-danger text-fixed-white">
          <strong className="me-auto">Message</strong>
          <span
            className="cursor-pointer"
            onClick={handleDangerToastClose}
            aria-label="Close"
            style={{ cursor: "pointer" }}
          />
        </Toast.Header>
        <Toast.Body>
          {/* Add your toast content here */}
          {errorMessage}
        </Toast.Body>
      </Toast>

      <Toast
        show={showSuccessToast}
        onClose={handleSuccessToastClose}
        id="successToast"
        className="toast-container position-fixed top-0 end-0 p-3  colored-toast bg-success-transparent"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >

        <Toast.Body>
          {/* Add your toast content here */}
          {successMessage}
        </Toast.Body>
      </Toast>
    </>

  )
}

export default AcademyYearGrid